module.exports = __webpack_public_path__ + "img/stars.992d674a.svg";